export default __webpack_public_path__ + "static/structure-image-db940772f86300c1dd4ed057f6d08496.png";